import styled from "@emotion/styled";
import Flex from "../../UI/Flex/Flex";

const FilterButton = styled.div(
  ({ theme }) => `
  background: ${theme.menuPrimary ? theme.gray.gray100 : theme.gray.gray300};
  color: black;
  display: flex;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  align-items: center;
  margin-right: 7px;
  margin-bottom: 5px;
  position: relative;
`
);

export default function AppliedPageFilters(props) {
  const { showFilters, executedCharts, visualizationId } = props;
  const hasFilter = executedCharts[visualizationId]?.filters?.length;

  if (!showFilters || !hasFilter) return null;

  return (
    <Flex alignItems="baseline" wrap="wrap">
      Filters:
      {executedCharts[visualizationId].filters
        .filter((filter) => filter.type)
        .map((filter, index) => (
          <FilterButton
            key={filter.type + "-" + index}
            style={{ marginLeft: 10 }}
          >{`${filter.label ?? filter.type}: ${filter.value}`}</FilterButton>
        ))}
    </Flex>
  );
}
